/**
 * @enum {string}
 */
export const regionLabels = {
    R3AO1: 'AOA',
    R3AE1: 'EUR',
    R3AA1: 'AMS',
};

/**
 * @enum {string}
 */
export const AdvancedSearchKey = {
    APPROVER: 'Approvers',
    COST_CENTER: 'Cost Centers',
    AGENT: 'Agents',
    PURCHASE_GROUP: 'Purchase Groups',
    PRN_BY_NUMBER: 'PrnByNumber',
    PRN_BY_INTERNAL: 'PrnByInternal',
    PRN_BY_WBS_ELEMENT: 'PrnByWBS',
};

/**
 * @enum {string}
 */
export const advancedSearchFormats = {
    [AdvancedSearchKey.APPROVER]: 'JSMITH or John Smith',
    [AdvancedSearchKey.PURCHASE_GROUP]: 'BB1',
    [AdvancedSearchKey.COST_CENTER]: 'Z200XXXXX',
    [AdvancedSearchKey.PRN_BY_NUMBER]: '0014XXX',
    [AdvancedSearchKey.PRN_BY_INTERNAL]: '0302XXXX',
    [AdvancedSearchKey.PRN_BY_WBS_ELEMENT]: 'AC-OOXXXXXXX',
};

export const rolesOptions = [
    { role: 'Operational Buyer', rule: '91200020' },
    { role: 'Strategic Buyer', rule: '91200028' },
    { role: 'Goods Receiver', rule: '91200026' },
];
